import { useCampaigns } from "api/campaigns";
import { useEvents } from "api/events";
import { useAppSelector } from "app/hooks";
import { Breadcrumbs, TopHeader } from "components/Header/TopHeader/TopHeader";
import {
  isInternalEventTrigger,
  sortCampaignTranslations,
} from "components/Layout/Campaign/Common/campaignHelpers";
import { prepareInitialValues } from "components/Layout/Campaign/utils/utils";
import { useMessage } from "hooks/intl";
import { useLocation } from "react-router-dom";
import { selectDefaultLanguageData } from "reduxState/translations/translationsSlice";
import { TimeBasedCampaign } from "types/campaigns";
import { links } from "utilities/links";
import { AutomationForm } from "./AutomationForm";

export function AddAutomation() {
  const { message } = useMessage();
  const { state } = useLocation();
  const { useCampaignData } = useCampaigns();
  const { data: campaignData } = useCampaignData(
    state?.campaignToDuplicate as string,
  );
  const { useCustomEventSchemaDetails } = useEvents();
  const { data: selectedSchemaDetails } = useCustomEventSchemaDetails(
    campaignData &&
      !isInternalEventTrigger(campaignData?.trigger) &&
      "event" in campaignData
      ? campaignData.event
      : undefined,
  );

  const defaultLang = useAppSelector(selectDefaultLanguageData);

  const initialValues = campaignData
    ? {
        ...prepareInitialValues({
          campaignData,
          selectedSchemaDetails,
        }),
        active: false,
        translations: sortCampaignTranslations(
          defaultLang?.code,
          campaignData?.translations || [],
        ).map((translation) =>
          translation.name
            ? {
                ...translation,
                name: `COPY - ${translation.name}`,
              }
            : translation,
        ),
      }
    : undefined;

  const breadcrumbs: Breadcrumbs = {
    parent: {
      label: message({ id: "automationCampaigns" }),
      path: links.automationsList,
    },
  };

  return (
    <>
      <TopHeader
        title={message({ id: "addAutomation" })}
        clearLink={links.automationsList}
        breadcrumbs={breadcrumbs}
      />
      <AutomationForm
        initialValues={initialValues as TimeBasedCampaign}
        isEditMode={state?.campaignToDuplicate}
        isDuplicationMode={state?.campaignToDuplicate}
      />
    </>
  );
}
